import React from 'react';
import { Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';

const Loading = ({ show = true }) => {

  if (show) {
    return (
      <div className="centered-page">
        <Spinner animation="border" role="status" variant="primary">
          <span className="sr-only">Loading...</span>
        </Spinner>
      </div>
    );
  } else {
    return null;
  }
}

export default Loading;

Loading.propTypes = {
  show: PropTypes.bool
};
